<template>
  <div class="sellWell">
      <div class="clear">
          <BigCourseCard v-if="isHaveCourse" class="float-left" :data="bigCourseCard"></BigCourseCard>
          <div class="small-content float-left">
              <SmallCourseCard v-for="(item, index) in data" :key="index" :data="item"></SmallCourseCard>
          </div>
      </div>
  </div>
</template>

<script>
import {mapActions} from 'vuex'
import {getIndexCourse} from 'api/indexApi'
import BigCourseCard from '../../../pc/components/bigCourseCard.vue'
import SmallCourseCard from '../../../pc/components/smallCourseCard.vue'
export default {
    name: "sellWell",
    props: ['ruletype'],
    data() {
        return {
            data: [],
            bigCourseCard: {},
            isHaveCourse:false
        }
    },
    mounted() {
        this.setLoading(true)
        getIndexCourse({
            data: {ruletype: this.ruletype},
            success: data=> {
                this.setLoading(false)
                    this.data = data.data.content
                    if(this.data && this.data.length>0){
                        this.isHaveCourse=true
                        this.bigCourseCard = this.data[0]
                        this.data.splice(0,1)
                    }
                    console.log('sell',this.data)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
        })
    },
    methods: {
        ...mapActions(['setLoading'])
    },
    components: {
        BigCourseCard,
        SmallCourseCard
    }
}
</script>

<style lang="scss" type="text/scss">
.sellWell {
    margin-bottom: 30px;
    height: 337px;
    .small-content {
        width: calc(100% - 384px)
    }
    @for $i from 5 through 8 {
        .smallCourseCard:nth-child(#{$i}){
            margin-bottom: 0
        }
    }
    
}
</style>